import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import FavoritesPanelConfig from "./FavoritesPanelConfig";
import StringUtil from "core/util/StringUtil";
import Query from "core/api/QueryComponent";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import { FavoriteSearch } from "./entities/FavoriteSearch";
import { Field } from "typegraph";
import CountResult from "common/entities/CountResult";
import NonIdealState from "common/fragments/NonIdealState";
import labelProvider from "./Favorites.labels";
import DataTable from "common/views/table/DataTable";
import * as columns from "./fragments/FavoriteSearchFragments";
import { BlockView } from "common/views/block/BlockView.view";
import PagingView from "common/views/paging/Paging.view";

const { Labels } = labelProvider;

interface IFavoritesState {
	pageNumber: number;
	pageSize: number;
}

function mapParams(params: any) {
	return { params };
}

class FavoritesQuery implements IPageableListQuery<FavoriteSearch> {
	@Field({
		entity: FavoriteSearch,
		params: mapParams,
		aliasFor: "article_saved_search_many"
	})
	public entities: null | FavoriteSearch[];

	@Field({
		entity: CountResult,
		params: mapParams,
		aliasFor: "article_saved_search_count"
	})
	public count: CountResult;
}

@Panel({
	id: "favorite-table",
	configClass: FavoritesPanelConfig,
	pageParams: true,
	labelProvider
})
export class FavoritesPanel extends React.PureComponent<
	IPanelProps<FavoritesPanelConfig, IFavoritesState>
> {
	public render() {
		const { config, pageParams } = this.props;

		const p = Object.entries(config.favoriteParams || {}).reduce(
			(a, [k, v]) => {
				a[k] = v;
				return a;
			},
			{}
		);

		if (config.pageSize) {
			p["pageSize"] = config.pageSize;
		}

		if (!p["pageSize"]) {
			p["pageSize"] = 6;
		}

		p["pageNumber"] = StringUtil.toInteger(pageParams["pageNumber"], 0);
		if (p["pageNumber"] < 1) {
			p["pageNumber"] = 0;
		}

		return (
			<div>
				<Query.Root entity={FavoritesQuery} args={p}>
					{({ loading, data }) => {
						if (
							!loading &&
							(data == null ||
								data.entities == null ||
								data.entities.length === 0)
						) {
							return (
								<NonIdealState
									title={<Labels.FavoriteEmpty />}
									description={
										<Labels.FavoriteEmptyDescription />
									}
								/>
							);
						}

						const lst = (data && data.entities) || null;

						return (
							<React.Fragment>
								<DataTable
									viewKeyPrefix="results"
									data={lst}
									params={p}
									entity={FavoriteSearch}
									getId={sub => sub.id}
									columns={Object.values(columns)}
								/>
								<BlockView viewKey="paging.block">
									<PagingView
										viewKey="paging"
										setPageNumber={pageNumber =>
											this.props.actions.pushPageParam(
												"pageNumber",
												pageNumber.toString()
											)
										}
										total={(data && data.count.count) || 0}
										pageNumber={p["pageNumber"]}
										pageSize={p["pageSize"]}
									/>
								</BlockView>
								<hr />
							</React.Fragment>
						);
					}}
				</Query.Root>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/favorites/FavoriteSearchTable.panel.tsx